import { Fragment } from 'react';
import PropTypes from 'prop-types';
import Error404 from 'jl-design-system/components/error-404/Error404';
import Error500 from 'jl-design-system/components/error-500/Error500';

import { ENV_VARS } from 'ENV_CONFIG';

import styles from './ErrorPage.scss';
import { CookiesError } from './CookiesError';

const errorCodeTemplate = {
  404: (
    <Error404
      returnTo={<a href={`${ENV_VARS.REACT_APP_BROWSE_HOST}/our-services`}>our services</a>}
    />
  ),
  500: (
    <Error500
      returnTo={<a href={`${ENV_VARS.REACT_APP_BROWSE_HOST}/our-services`}> our services</a>}
    />
  ),
  503: (
    <section className={styles.ErrorPage}>
      <div className={styles.container}>
        <h1 className={styles.ErrorPage__title}>Something&apos;s gone wrong</h1>
        <p className={styles.ErrorPage__message}>
          <Fragment>
            While we fix it, please contact your&nbsp;
            <a href={`${ENV_VARS.REACT_APP_BROWSE_HOST}/our-shops`}>local shop</a>
            &nbsp; to book an appointment.
          </Fragment>
        </p>
      </div>
    </section>
  ),
  COOKIES_ERROR: <CookiesError />,
};

export const ErrorPage = ({ errorType = false }) => errorCodeTemplate[errorType];

ErrorPage.propTypes = {
  errorType: PropTypes.oneOfType([PropTypes.number, PropTypes.bool, PropTypes.string]),
};
